import { DOCTYPES } from '@/constants/doctypes'
import { PERMISSIONS } from '@/constants/permissions'
import { createSingleViewRoutes } from '@/routers/routes/createDoctypeRoutes'

const { home: routeSalesDashboardHome, root: routeSalesDashboardRoot } = createSingleViewRoutes({
  doctypes: {
    [DOCTYPES.CUSTOMER]: [PERMISSIONS.READ],
    [DOCTYPES.OPPORTUNITY]: [PERMISSIONS.READ],
    [DOCTYPES.SALES_ORDER]: [PERMISSIONS.READ],
  },
  name: 'sales-dashboard',
  path: 'sales-dashboard',
  view: async () => await import('@/components/views/sales/SalesDashboard.vue'),
})

export { routeSalesDashboardHome, routeSalesDashboardRoot }
